import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsFormExpiredSvg = lazy(() => import('./svg-components/digital-forms-form-expired-svg'));

const DigitalFormsFormExpiredSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsFormExpiredSvg {...rest} />
  </Suspense>
);

export default DigitalFormsFormExpiredSvg;
